var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M2.48345 2.00453C1.03295 3.21329 1.2747 5.12714 1.57689 5.93298L2.18127 6.83954L7.01627 11.3724C8.46677 10.1636 12.2057 6.68271 12.4557 5.93298C12.7578 5.02641 12.9996 2.97153 11.5491 2.00453C10.0986 1.03753 7.92284 2.40745 7.01627 3.21329C6.10971 2.30672 3.93396 0.795783 2.48345 2.00453Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.20875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeTwitter);
export default __webpack_public_path__ + "static/media/like_twitter.93e3a1f8e95f9f723c87378885a04c91.svg";
export { ForwardRef as ReactComponent };